import { useCallback, useMemo, useState } from 'react';

const STORAGE_PREFIX = 'suigar.one-time';

export function useOneTimeFlag(identifier?: string | null) {
	const storageKey = useMemo(() => {
		const trimmed = identifier?.trim();
		if (!trimmed) return null;
		return `${STORAGE_PREFIX}.${trimmed}`;
	}, [identifier]);

	const [hasSeen, setHasSeen] = useState<boolean>(() => {
		if (typeof window === 'undefined') return false;
		if (!storageKey) return false;
		return window.localStorage.getItem(storageKey) === '1';
	});

	const markSeen = useCallback(() => {
		if (!storageKey) return;
		setHasSeen(true);
		try {
			if (typeof window !== 'undefined') {
				window.localStorage.setItem(storageKey, '1');
			}
		} catch (error) {
			console.warn('Failed to persist one-time flag', { storageKey, error });
		}
	}, [storageKey]);

	return {
		isConfigured: Boolean(storageKey),
		hasSeen: storageKey ? hasSeen : true,
		markSeen,
	};
}
